import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kys-binary-checks',
  templateUrl: './kys-binary-checks.component.html',
  styleUrls: ['./kys-binary-checks.component.scss']
})
export class KysBinaryChecksComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  openModal(){
    const buttonModal = document.getElementById("openModalButton")
    console.log('buttonModal', buttonModal)
    buttonModal.click()
  }

}
